"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminTitle = void 0;
const react_1 = __importDefault(require("react"));
const common_1 = require("../../../common");
exports.AdminTitle = react_1.default.memo(({ oneDepthMenu, twoDepthMenu, children, handlerPreviousMenu, }) => {
    return (react_1.default.createElement("div", { className: "admin-title" },
        react_1.default.createElement("div", { className: "admin-title-left" },
            react_1.default.createElement("p", null, oneDepthMenu),
            twoDepthMenu && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(common_1.Icon, { className: "arrow-right", icon: "arrow", size: 32 }),
                react_1.default.createElement("p", null, twoDepthMenu),
                react_1.default.createElement(common_1.Button, { className: "menu_close", option: {
                        buttonBeforeIcon: {
                            show: true,
                            size: 24,
                            name: 'detail-delete',
                        },
                    }, onClick: handlerPreviousMenu })))),
        react_1.default.createElement("div", { className: "admin-title-right" }, children)));
});
